import { CommandActions, DocumentActions } from "../../actions/notification";

export const notificationMiddleware = ({dispatch, getState}: {dispatch: any, getState: any}) => (next: any) => (action: CommandActions) => {
    next(action);


};


